import animation from './foundation/animation'
import {breakpoints, mediaQueries, mq, multipliers, viewportsArray} from './foundation/breakpoints'
import buttons from './foundation/buttons'
import colors from './foundation/colors'
import focus from './foundation/focus'
import fonts from './foundation/fonts'
import layout from './foundation/layout'
import radius from './foundation/radius'
import {spaces} from './foundation/spaces'
import typography from './foundation/typography'
import {expandVariants, normalizeStyles} from './utils'

export const theme: BaseTheme.Theme = {
  animation,
  breakpoints,
  buttons,
  colors,
  disableScaling: false,
  expandVariants,
  focus,
  fonts,
  layout,
  mediaQueries,
  mq,
  multipliers,
  normalizeStyles,
  radius,
  spaces,
  typography,
  viewportsArray,
}

export type Theme = typeof theme
